import React from 'react';
import ReactDOM from 'react-dom';
import { useTranslation, Trans } from 'react-i18next';
import cn from 'classnames';
import { ThemeOverride, ThemeOptions, } from '@wix/da-react-context/pkg/ThemeContext';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import PremiumIcon from '@wix/da-ds/pkg/Icons/PremiumFolder';
import CloseButton from '../../../Button/CloseButton';
import { usePortalNode } from '../../../Popover/hooks/usePortalNode';
import s from './FellaTooltip.scss';
var TOOLTIP_PLACEMENT_THRESHOLD = 250;
var FellaPortal = function (_a) {
    var children = _a.children;
    var portalContainer = usePortalNode('promotion-fella', s['portal']);
    return portalContainer && ReactDOM.createPortal(children, portalContainer);
};
var FellaTooltip = function (_a) {
    var children = _a.children, top = _a.top, left = _a.left, forcePlacementRight = _a.forcePlacementRight, onDismiss = _a.onDismiss;
    var t = useTranslation().t;
    var placement = forcePlacementRight
        ? 'right'
        : top > TOOLTIP_PLACEMENT_THRESHOLD
            ? 'above'
            : 'below';
    return (React.createElement(FellaPortal, null,
        React.createElement(ThemeOverride, { theme: ThemeOptions.DARK },
            React.createElement("div", { className: cn(s['root'], s["placement-" + placement]), style: { top: top, left: left } },
                React.createElement(CloseButton, { className: s['close'], iconSize: IconSize.SMALL, onClick: onDismiss }),
                React.createElement("div", { className: s['tooltip'] },
                    React.createElement("div", { className: s['tooltip-content'] },
                        React.createElement(PremiumIcon, { className: s['premium-icon'] }),
                        React.createElement("div", { className: s['title'] },
                            React.createElement(Trans, { i18nKey: 'deviationview.tierFellaTooltip.title' },
                                "Introducing",
                                React.createElement("br", null),
                                "DeviantArt Subscriptions!")),
                        React.createElement("div", { className: s['text'] },
                            React.createElement(Trans, { i18nKey: t('deviationview.tierFellaTooltip.text') },
                                "Subscribe to your favorite artists to",
                                React.createElement("br", null),
                                "unlock exclusive content.")),
                        React.createElement(TextButton, { size: "small", variant: "approval-green", onClick: onDismiss }, t('deviationview.tierFellaTooltip.dismissButton')))),
                React.createElement("div", { className: s['card'] }, children)),
            React.createElement("div", { className: s['overlay'], onClick: onDismiss }))));
};
FellaTooltip.displayName = 'FellaTooltip';
export default FellaTooltip;
//# sourceMappingURL=FellaTooltip.js.map